import OnboardingTable from './OnboardingTable';

export default OnboardingTable;
